import { getCurrentInstance, inject } from 'vue'

export const FRONTEND_ENVIRONMENT_KEY = Symbol('frontend-environment')

export class FrontendEnvironment {
  getEnvVar() {
    return undefined
  }

  getHostname() {
    return ''
  }
}

export class BrowserFrontendEnvironment extends FrontendEnvironment {
  constructor({
    envAccessor = () => undefined,
    processEnvAccessor = () => process.env,
    locationAccessor = () => (typeof window !== 'undefined' ? window.location : undefined),
  } = {}) {
    super()
    this.envAccessor = envAccessor
    this.processEnvAccessor = processEnvAccessor
    this.locationAccessor = locationAccessor
  }

  getEnvVar(name) {
    try {
      const env = this.envAccessor?.()
      if (env && Object.prototype.hasOwnProperty.call(env, name)) {
        return env[name]
      }
    } catch (_error) {
      return undefined
    }

    try {
      const processEnv = this.processEnvAccessor?.()
      if (processEnv && Object.prototype.hasOwnProperty.call(processEnv, name)) {
        return processEnv[name]
      }
    } catch (_error) {
      return undefined
    }

    return undefined
  }

  getHostname() {
    try {
      return this.locationAccessor?.()?.hostname ?? ''
    } catch {
      return ''
    }
  }
}

export const appFrontendEnvironment = new BrowserFrontendEnvironment()

export function useFrontendEnvironment() {
  if (!getCurrentInstance()) {
    return appFrontendEnvironment
  }
  return inject(FRONTEND_ENVIRONMENT_KEY, appFrontendEnvironment)
}
